import { Box, Flex, useColorMode } from "@chakra-ui/react";
import Logo from "@/src/components/Logo";
import React from "react";
import CustomLink from "@/src/components/CustomLink";

const SidebarContent = (props) => {
  const { children, ...rest } = props;
  const { colorMode } = useColorMode();
  return (
    <Box
      as="nav"
      flex={"0 1 auto"}
      position={"relative"}
      maxH={"100vh"}
      zIndex={3}
      bg={`${colorMode === "light" ? "white" : "#023b31"}`}
      borderColor={`${colorMode === "light" ? "gray.20" : "brand.700"}`}
      borderRightWidth="1px"
      w={{ base: "full", "2xl": "400px" }}
      {...rest}
    >
      <Flex
        w={{ base: "full", "2xl": "400px" }}
        zIndex={2}
        px="4"
        h={20}
        align="center"
        position={"sticky"}
        top={0}
        bg={`${colorMode === "light" ? "white" : "#023b31"}`}
        borderBottomWidth="1px"
        borderRightWidth={"1px"}
        borderColor={`${colorMode === "light" ? "gray.200" : "brand.700"}`}
      >
        <CustomLink to={"/"}>
          <Logo width={"215px"} height={"41px"} />
        </CustomLink>
      </Flex>
      <Flex
        direction="column"
        as="nav"
        position={"fixed"}
        top={20}
        mt={4}
        mb={8}
        bottom={16}
        left={0}
        fontSize="sm"
        color="gray.600"
        aria-label="Main Navigation"
        overflowY="auto"
        maxH={"100vh"}
        maxW={{ base: "280px", "2xl": "400px" }}
      >
        {children}
      </Flex>
    </Box>
  );
};

export default SidebarContent;
